@if (collectionId != null) {
  <div class="pc-el" data-step="1" data-intro="Click on a row to open the Event." data-position="right">

    <!-- ── Toolbar ─────────────────────────────────────────────────────── -->
    <div class="pc-el-toolbar">
      <div class="pc-el-search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Search events…"
          [(ngModel)]="searchTerm"
          (ngModelChange)="applyFilters()" />
        @if (searchTerm) {
          <button class="pc-el-search-clear" type="button" (click)="searchTerm = ''; applyFilters()" title="Clear search">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      @if (phaseOptions.length > 1) {
        <div class="pc-el-phases">
          @for (phase of phaseOptions; track phase) {
            <button
              type="button"
              class="pc-el-phase-chip"
              [class.active]="selectedPhase === phase"
              (click)="selectPhase(phase)">
              {{ phase }}
            </button>
          }
        </div>
      }

      <mat-slide-toggle class="pc-el-toggle" [(ngModel)]="hideCompleted" (change)="applyFilters()">
        Hide completed
      </mat-slide-toggle>

      <span class="pc-el-spacer"></span>

      <span class="pc-el-count">{{ filteredRows.length }} of {{ allRows.length }}</span>

      <button mat-raised-button class="gridbtn pc-el-export" (click)="exportAsCSV()">
        <mat-icon>download</mat-icon> CSV
      </button>
    </div>

    <!-- ── Table ───────────────────────────────────────────────────────── -->
    <p-table
      [value]="filteredRows"
      [columns]="columns"
      dataKey="uid"
      [loading]="loading"
      [scrollable]="true"
      scrollHeight="calc(100vh - 430px)"
      [rowHover]="true"
      sortField="dateMs"
      [sortOrder]="1"
      [reorderableColumns]="true"
      (onColReorder)="onColReorder($event)"
      styleClass="p-datatable-sm pc-event-table">

      <ng-template pTemplate="header" let-cols>
        <tr>
          @if (canCompleteEvent) {
            <th class="pc-el-check-col">
              <mat-checkbox
                color="primary"
                [checked]="allVisibleChecked"
                [indeterminate]="someVisibleChecked"
                (change)="toggleAll($event.checked)">
              </mat-checkbox>
            </th>
          }
          @for (col of cols; track col.key) {
            @if (col.sortable) {
              <th pReorderableColumn [pSortableColumn]="col.field" [style.min-width]="col.minWidth">
                {{ col.header }} <p-sortIcon [field]="col.field" />
              </th>
            } @else {
              <th pReorderableColumn [style.min-width]="col.minWidth">{{ col.header }}</th>
            }
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-cols="columns">
        <tr
          class="pc-row"
          [class.pc-row-done]="row.event.completed"
          [class.pc-row-dirty]="isDirty(row)"
          (click)="eventClick(row)">
          @if (canCompleteEvent) {
            <td class="pc-el-check-col" (click)="$event.stopPropagation()">
              <mat-checkbox color="primary" [(ngModel)]="row.event.completed"></mat-checkbox>
            </td>
          }
          @for (col of cols; track col.key) {
            <td [style.min-width]="col.minWidth">
              @switch (col.type) {
                @case ('priority') {
                  @if (row.event.highPriority) {
                    <mat-icon class="pc-el-priority" title="High priority">error_outline</mat-icon>
                  }
                }
                @case ('dayOfWeek') {
                  @if (row.dateMs) {
                    <span class="pc-el-dow">{{ row.dateMs | date:'EEE' }}</span>
                  }
                }
                @case ('date') {
                  @if (row.dateMs) {
                    <span>{{ row.dateMs | date:'MM/dd/yyyy' }}</span>
                  }
                }
                @case ('notes') {
                  @if (row.notes.length > 0) {
                    <ul class="pc-el-notes">
                      @for (note of row.notes; track $index) {
                        <li [innerHtml]="note | safeHtml"></li>
                      }
                    </ul>
                  }
                }
                @case ('tags') {
                  @if (row.tags.length > 0) {
                    <div class="pc-el-tags">
                      @for (tag of row.tags; track tag) {
                        <span class="pc-el-tag">{{ tag }}</span>
                      }
                    </div>
                  }
                }
                @case ('minutes') {
                  @if (row[col.field] != null) {
                    <span>{{ row[col.field] }} min</span>
                  }
                }
                @case ('percent') {
                  @if (row[col.field] != null) {
                    <span>{{ row[col.field] }}%</span>
                  }
                }
                @default {
                  @if (col.field === 'description') {
                    <span class="pc-el-desc">{{ row.description }}</span>
                  } @else {
                    <span>{{ row[col.field] }}</span>
                  }
                }
              }
            </td>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-cols>
        <tr>
          <td [attr.colspan]="(canCompleteEvent ? 1 : 0) + columns.length" class="pc-el-empty">
            @if (loading) {
              Loading events…
            } @else if (allRows.length === 0) {
              No events in this schedule yet.
            } @else {
              No events match the current filters.
            }
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- ── Pending-changes bar ─────────────────────────────────────────── -->
    @if (hasPendingChanges) {
      <div class="pc-el-pending">
        <span class="pc-el-pending-badge">{{ pendingChanges.length }}</span>
        <span class="pc-el-pending-text">
          {{ pendingChanges.length === 1 ? 'task change pending' : 'task changes pending' }}
        </span>
        <button mat-button class="pc-el-pending-discard" (click)="undoChanges()">Discard</button>
        <button mat-raised-button color="primary" class="pc-el-pending-save" (click)="saveChanges()">
          <mat-icon>save</mat-icon> Save
        </button>
      </div>
    }
  </div>
}
